module.exports = __webpack_public_path__ + "img/1003.f4bc98e5.jpg";